module.exports = __webpack_public_path__ + "static/media/work-flavourly-tiny.48e909d9.jpg";